import { HEARTBEAT_TIMEOUT } from '../config';

import Crud, { HEARTBEAT } from '../api/crud';

import store from '../store';

const api = (function _detectAPI() {
   // if (process.env.NODE_ENV !== 'production') {
   //    const Mock = require('../../mocks/auth').default;
   //    return new Mock();
   // }
   return new Crud(HEARTBEAT);
})();


let _nextHeartbeatTime = 0;

class HeartbeatHelper {
   ping() {
      if (!store.state.auth.isAuth) {
         _nextHeartbeatTime = 0;
         return;
      }

      const now = performance.now();

      _nextHeartbeatTime = _nextHeartbeatTime || now + HEARTBEAT_TIMEOUT;

      if ( now > _nextHeartbeatTime ) {
         _nextHeartbeatTime = now + HEARTBEAT_TIMEOUT;
         api.save({});
      }
   }
}

export default new HeartbeatHelper();
